//import axios from "axios";
import { QueryFunctionContext } from '@tanstack/react-query';
import { GlobalConfig, WorksheetReportTemplateConfig, MeasurementTableBlockConfig } from "./type";

let lastResults : { 
  lastGlobalConfigQuery: GlobalConfig | null, 
  lastWksRptTmplConfigQuery: WorksheetReportTemplateConfig | null,
  lastMeasTblBlkConfigQUery: MeasurementTableBlockConfig | null,
} = {lastGlobalConfigQuery : null, 
  lastWksRptTmplConfigQuery : null, 
  lastMeasTblBlkConfigQUery : null};

export const getGlobalConfig = async (context: QueryFunctionContext): Promise<GlobalConfig> => {
  context;
  const globalCfg: GlobalConfig = {
    language: '',
  };

  lastResults.lastGlobalConfigQuery = globalCfg;
  return globalCfg;
}

export const getWorksheetReportTemplateConfig = async (context: QueryFunctionContext): Promise<WorksheetReportTemplateConfig> => {
  //const res = await axios.get("https://jsonplaceholder.typicode.com/posts");
  //return res.data;
  performance.mark('cnf_data_begin');
  let tblBlkOrders = new Array<string>();
  let tblBlkCfgs : {[blockId: string]: MeasurementTableBlockConfig} = {};
  [...Array(context.meta?.numBlocks).keys()].forEach(elem => {
    const tblblkcfg: MeasurementTableBlockConfig = {
      blockName: 'block_' + elem,
      blockType: '',
      langId: '',
      paramCodes: [...Array(context.meta?.numParams).keys()].map(subelem => 'param_'+elem+'_'+subelem),
    };
    tblBlkOrders.push('block_' + elem);
    tblBlkCfgs['block_' + elem] = tblblkcfg;
  });
  performance.mark('cnf_data_end');
  performance.measure(
    'cnf_data',
    'cnf_data_begin',
    'cnf_data_end',
  );
  const config :WorksheetReportTemplateConfig = {
    measTblBlkOrder: tblBlkOrders,
    measTblBlkConfig: tblBlkCfgs,
    findingConfig: {},
    //graphConfig: {},
    //historyConfig: {},
    reportLayoutTemplateConfig: {},
  }

  const perfConf = performance.getEntriesByName('cnf_data');
  console.log('config generation times (ms)' + perfConf[0].duration);

  return Promise.resolve(config);
};

